import v1user from './v1user'

export default {
  v1user,
}
